import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_Pathway = {
    _v1: {
        duplicatePathway: { method: HttpMethod.POST, path: '/v1/pathway/duplicate', timeout: Minute * 5 },
        deletePathway: { method: HttpMethod.DELETE, path: '/v1/pathway/delete-pathway' },
        createPathway: { method: HttpMethod.POST, path: '/v1/pathway/create-pathway' },
        createChildPathway: { method: HttpMethod.POST, path: '/v1/pathway/create-child-pathway' },
        detachPathwayFromParent: { method: HttpMethod.POST, path: '/v1/pathway/detach-pathway-from-parent' },
        togglePathwayArchiveStatus: { method: HttpMethod.POST, path: '/v1/pathway/toggle-pathway-archive-status' },
        togglePathwayUnderConstruction: { method: HttpMethod.POST, path: '/v1/pathway/toggle-pathway-under-construction' }
    }
};
export const ApiDef_PathwayHtml = {
    _v1: {
        setPathwayHtml: { method: HttpMethod.POST, path: '/v1/pathway/set-html', timeout: Minute * 5 },
        removePathwayHtml: { method: HttpMethod.POST, path: '/v1/pathway/remove-html', timeout: Minute },
    }
};
//# sourceMappingURL=api-def.js.map